import { createSlice } from "@reduxjs/toolkit";

const orgDetailsSlice = createSlice({
  name: "orgDetails",
  initialState: {
    // Store organization details by orgId
    organizations: {},
    // Track loading states per organization
    loadingStates: {},
    // Track fetch timestamps per organization
    fetchTimestamps: {},
  },
  reducers: {
    fetchOrgDetailsStart: (state, action) => {
      const orgId = action.payload;
      state.loadingStates[orgId] = true;
    },
    fetchOrgDetailsSuccess: (state, action) => {
      const { orgId, data } = action.payload;
      state.organizations[orgId] = data;
      state.loadingStates[orgId] = false;
      state.fetchTimestamps[orgId] = Date.now();
    },
    fetchOrgDetailsFailure: (state, action) => {
      const orgId = action.payload;
      state.loadingStates[orgId] = false;
    },
    clearOrgDetails: (state, action) => {
      const orgId = action.payload;
      if (orgId) {
        delete state.organizations[orgId];
        delete state.loadingStates[orgId];
        delete state.fetchTimestamps[orgId];
      }
    },
    clearAllOrgDetails: (state) => {
      state.organizations = {};
      state.loadingStates = {};
      state.fetchTimestamps = {};
    },
  },
});

export const {
  fetchOrgDetailsStart,
  fetchOrgDetailsSuccess,
  fetchOrgDetailsFailure,
  clearOrgDetails,
  clearAllOrgDetails,
} = orgDetailsSlice.actions;

// Selectors
export const selectOrgDetails = (orgId) => (state) =>
  state.orgDetails.organizations[orgId];
export const selectIsOrgDetailsLoading = (orgId) => (state) =>
  state.orgDetails.loadingStates[orgId] || false;
export const selectOrgDetailsFetchTime = (orgId) => (state) =>
  state.orgDetails.fetchTimestamps[orgId];

export default orgDetailsSlice.reducer;
